import { BUSINESS } from "../data";
import { Phone, Globe, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="relative bg-[#1E3F20] text-white grain overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <h2 className="font-serif-display text-5xl md:text-7xl font-light leading-none tracking-tight">
              JMG Landscape
            </h2>
            <p className="text-white/70 font-light mt-5 max-w-md leading-relaxed">
              Premium landscape design, maintenance and hardscaping serving Dallas,
              Georgia and surrounding communities.
            </p>
            <a
              href="#contact"
              className="inline-block mt-8 rounded-sm bg-[#F7F5F0] text-[#1E3F20] px-7 py-3.5 text-sm font-semibold hover:bg-white transition-colors"
            >
              Request a Quote
            </a>
          </div>

          <div className="grid sm:grid-cols-2 gap-10 lg:justify-items-end">
            <div className="space-y-5">
              <p className="text-xs uppercase tracking-[0.2em] text-[#C7D6B8] font-semibold">Get in Touch</p>
              <a href={`tel:${BUSINESS.phoneRaw}`} data-testid="footer-phone" className="flex items-center gap-3 text-white/90 hover:text-white transition-colors">
                <Phone size={18} strokeWidth={1.5} /> {BUSINESS.phone}
              </a>
              <a href={BUSINESS.websiteUrl} target="_blank" rel="noreferrer" data-testid="footer-website" className="flex items-center gap-3 text-white/90 hover:text-white transition-colors">
                <Globe size={18} strokeWidth={1.5} /> {BUSINESS.website}
              </a>
              <a href={BUSINESS.mapsUrl} target="_blank" rel="noreferrer" data-testid="footer-address" className="flex items-start gap-3 text-white/90 max-w-[220px] hover:text-white transition-colors">
                <MapPin size={18} strokeWidth={1.5} className="mt-0.5 shrink-0" /> {BUSINESS.address}
              </a>
            </div>

            <div className="space-y-3">
              <p className="text-xs uppercase tracking-[0.2em] text-[#C7D6B8] font-semibold">Services</p>
              {["Landscape Design", "Lawn Maintenance", "Patios & Stone Walls", "Seasonal Cleanup"].map((s) => (
                <a key={s} href="#services" className="block text-white/80 hover:text-white transition-colors text-sm">{s}</a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/15 mt-16 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-sm text-white/50">
          <span>© {new Date().getFullYear()} JMG Landscape. All rights reserved.</span>
          <span>Dallas, Georgia</span>
        </div>
      </div>
    </footer>
  );
};
